import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9noaizffyc: FaireBrandEntity = {
  token: "b_9noaizffyc",
  type: "brand",
  name: "Handker Bandanas",
  avatarUrl:
    "https://cdn.faire.com/fastly/e4ac73ec306516d79eaef7e1410756193ebea90170d5132174c4afa419901ce5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/14de88e659a6a824285a78000b9554cc4819d2c74a6fe7a9fd959b7eea3c3d86.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e4ac73ec306516d79eaef7e1410756193ebea90170d5132174c4afa419901ce5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14de88e659a6a824285a78000b9554cc4819d2c74a6fe7a9fd959b7eea3c3d86.jpeg",
  location: "Fulton, MO, USA",
  minimumOrderDollars: 140,
  rating: 5,
  reviewCount: 695,
  isTopShop: true,
  isInsider: true,
  description:
    'We originally named the company "Hemlock Goods" because the hemlock plant is pretty but poisonous, tender yet tenacious. We see the spirit of the hemlock plant in the women we admire, and it\'s what inspires the bandanas we create. Recently we changed the name to Handker to embody our primary product: handkerchiefs (aka bandanas) and also the delightful craving feeling that comes with the homonym "hanker". \n\nHandker bandanas were made to be beautiful, yes, but they\'re also tough. They can hold your hair back, carry an outfit, pick up spills, and store your beloved treasures and favorite snacks. The possibilities are endless with these hardwearing, artfully designed handkerchiefs. And with a Handker bandana in your possession, your possibilities are endless too.',
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:47.842Z",
    importedBy: "entity-db-cli",
  },
};
